import {
    Avatar,
    Button,
    Grid,
    List,
    ListItem,
    ListItemAvatar,
    ListItemText,
} from '@mui/material';
import ExternalScreen from '../../components/fragments/ExternalScreen';
import ListEmpty from '../../components/fragments/ListEmpty';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';

export default function ScreenStartChat() {
    const navigate = useNavigate();
    const state = useSelector((st) => st);
    const { pastors, busy } = state.list2;

    return (
        <ExternalScreen loading={busy['pastors']} title="Start Chat">
            <Grid item xs={12}>
                {!!(pastors?.length < 1) && <ListEmpty />}
                <List>
                    {pastors?.map(
                        ({
                            id,
                            firstName,
                            surname,
                            links: { avatar },
                            estate,
                            username,
                        }) => (
                            <ListItem sx={{ p: 0 }} key={id}>
                                <ListItemAvatar>
                                    <Avatar src={avatar}>
                                        {firstName?.slice(0, 1)}
                                    </Avatar>
                                </ListItemAvatar>
                                <ListItemText
                                    secondary={estate}
                                    primary={`${firstName} ${surname}`}
                                />
                                <Button
                                    onClick={() =>
                                        navigate(`/chat/${username}`, {})
                                    }
                                    size="small"
                                    variant="outlined"
                                >
                                    Message
                                </Button>
                            </ListItem>
                        )
                    )}
                </List>
            </Grid>
        </ExternalScreen>
    );
}
